import { Component, OnInit, Output, ViewChild, EventEmitter, Input } from '@angular/core';

@Component({
  selector: 'guiaCertificacion',
  templateUrl: './guiaCertificacion.component.html',
  styleUrls: ['./guiaCertificacion.component.css']
})
export class GuiaCertificacionComponent implements OnInit {
  dataSource: any;
  @Output()
  sectorEsById = new EventEmitter<any>();
  @Output()
  backTo = new EventEmitter<number>();

  @Input() idSector:number;  
  @Input() title: string; 
  @Input() padre: number; 
  @Input() codigoEC: string;

  
  constructor() {
  }

  ngOnInit(): void {

  }

  back(){
   
    this.backTo.emit(this.idSector);
  }

}
